// extracted by mini-css-extract-plugin
module.exports = {"button":"BridgeLink_button__oTo9q","modalOverride":"BridgeLink_modalOverride__8Q2SO","closeButtonOverride":"BridgeLink_closeButtonOverride__1vb4z"};